/**
 * The boot preloader (index.html #boot-loader): shown from the first byte of
 * HTML until the app's first screen is ready, then faded out over it.
 *
 * "Ready" means the app has rendered and no page-level loader (PageLoader:
 * the session check, a lazy route's code) is still waiting. It stays up for
 * at least MIN_VISIBLE_MS from navigation start so it never flickers, and a
 * safety timeout makes sure it can never trap the app behind it.
 */
const MIN_VISIBLE_MS = 700
const FADE_MS = 280
const SETTLE_MS = 60
const SAFETY_MS = 12000

let holds = 0
let mounted = false
let done = false
let settleTimer = null

function hide() {
  if (done || holds > 0) return
  done = true
  const node = typeof document !== 'undefined' && document.getElementById('boot-loader')
  if (!node) return
  node.classList.add('is-done')
  setTimeout(() => node.remove(), FADE_MS)
}

function schedule() {
  if (done || !mounted || holds > 0) return
  clearTimeout(settleTimer)
  // A beat for a loader that mounts in the next commit (a lazy route) to claim the screen.
  settleTimer = setTimeout(() => {
    if (done || holds > 0) return
    const elapsed = typeof performance !== 'undefined' ? performance.now() : MIN_VISIBLE_MS
    setTimeout(hide, Math.max(0, MIN_VISIBLE_MS - elapsed))
  }, SETTLE_MS)
}

/** Keep the boot preloader up while a page-level wait is in progress. Returns the release. */
export function holdBootLoader() {
  if (done) return () => {}
  holds += 1
  let released = false
  return () => {
    if (released) return
    released = true
    holds -= 1
    schedule()
  }
}

/** The app has rendered its first frame. */
export function markAppMounted() {
  mounted = true
  schedule()
}

if (typeof window !== 'undefined') {
  setTimeout(() => {
    holds = 0
    mounted = true
    hide()
  }, SAFETY_MS)
}
